@if (courses().length > 0) {
	<div class="grid gap-8 mt-8">
		<uc-clearing-university-card
			[uniName]="uniName()"
			[uniSlug]="uniSlug()"
			[uniId]="uniId()"
			[uniLogo]="uniLogo()"
			[uniCover]="uniCoverImage()"
			[externalUrl]="externalUrl()"
			[clientFeatures]="clientFeatures()"
			[saved]="isFavourite()"
			[recommended]="recommendedPercentage()"
			[displaySeeCoursesBtn]="false"
			[phoneNumber]="uniPhoneNumber()"
			[searchTerm]="searchTerm()"
			[displaySearchTerm]="true"
			[cleSearchOrderPosition]="cleSearchOrderPosition()"
			[privacyPolicyUrl]="privacyPolicyUrl()"
			[isHECoSSubject]="null"
			[degreeLevel]="na"
			[region]="na"
		>
			<div courses class="mt-6 border-t">
				<uc-clearing-course-card-container
					[courses]="courses()"
					[clientFeatures]="clientFeatures()"
					[uniSlug]="uniSlug()"
					[uniId]="uniId()"
					[externalUrl]="externalUrl()"
					[phoneNumber]="uniPhoneNumber()"
					[uniName]="uniName()"
					[cleSearchOrderPosition]="cleSearchOrderPosition()"
					[privacyPolicyUrl]="privacyPolicyUrl()"
					[searchTerm]="searchTerm()"
					[isHECoSSubject]="null"
					[degreeLevel]="na"
					[region]="na"
				/>
			</div>
		</uc-clearing-university-card>
	</div>
}
